import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PublicHeader from "@components/Header/PublicHeader";
import styles from "@components/Layout/Layout.module.css";

/**
 * PublicLayout Component
 *
 * Layout for unauthenticated routes: header and main content only.
 * Used when the user has no token; auth is decided in App, not here.
 *
 * @param {React.ReactNode} children - Child components to render in main content area
 */
const PublicLayout = ({ children }) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const staffAuth = [
    "/",
    "/login",
    "/verify-email",
    "/reset-password",
    "/accept-invite",
  ].includes(pathname);
  return (
    <main className={styles.appContainer} role="main">
      <PublicHeader staffAuth={staffAuth} />
      <div
        className={`${styles.appBody} ${staffAuth ? styles.publicAuthBody : ""}`}
      >
        <section
          className={styles.mainContent}
          aria-label={t("common.mainContent")}
        >
          {children}
        </section>
      </div>
    </main>
  );
};

export default PublicLayout;
